module.exports = __webpack_public_path__ + "fontawesome-webfont.7149833697a959306ec3.eot";


//////////////////
// WEBPACK FOOTER
// E:/Thakur/github/Stratgist-latest/Stratgist LandingPage/src/assets/font-awesome/fonts/fontawesome-webfont.eot?v=4.2.0
// module id = ../../../../../src/assets/font-awesome/fonts/fontawesome-webfont.eot?v=4.2.0
// module chunks = 2